import { cn } from '~/src/lib/utils'

interface NavRecentsIconProps {
  className?: string
}

const NavRecentsIcon: React.FC<NavRecentsIconProps> = ({ className }) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('h-6 w-6', className)}
    >
      <g clipPath='url(#clip0_1_13)'>
        <path
          d='M11.6667 18.6667C11.6667 19.4 12.2667 20 13 20C13.7333 20 14.3333 19.4 14.3333 18.6667C14.3333 17.9333 13.7333 17.3333 13 17.3333C12.2667 17.3333 11.6667 17.9333 11.6667 18.6667ZM11.6667 0V5.33333H14.3333V2.77333C18.8533 3.42667 22.3333 7.29333 22.3333 12C22.3333 17.16 18.16 21.3333 13 21.3333C7.84 21.3333 3.66667 17.16 3.66667 12C3.66667 9.76 4.45333 7.70667 5.77333 6.10667L13 13.3333L14.88 11.4533L5.81333 2.38667V2.41333C2.89333 4.6 1 8.06667 1 12C1 18.6267 6.36 24 13 24C19.6267 24 25 18.6267 25 12C25 5.37333 19.6267 0 13 0H11.6667ZM21 12C21 11.2667 20.4 10.6667 19.6667 10.6667C18.9333 10.6667 18.3333 11.2667 18.3333 12C18.3333 12.7333 18.9333 13.3333 19.6667 13.3333C20.4 13.3333 21 12.7333 21 12ZM5 12C5 12.7333 5.6 13.3333 6.33333 13.3333C7.06667 13.3333 7.66667 12.7333 7.66667 12C7.66667 11.2667 7.06667 10.6667 6.33333 10.6667C5.6 10.6667 5 11.2667 5 12Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_1_13'>
          <rect width='25' height='25' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NavRecentsIcon
